import React from 'react';

interface OverlaySkeletonType {
  isVisible?: boolean;
  className?: string;
  children?: React.ReactNode;
  variant?: 'default' | 'compact' | 'minimal';
}

const OverlaySkeleton: React.FC<OverlaySkeletonType> = ({
  isVisible = true,
  className = '',
  children,
  variant = 'default',
}) => {
  if (!isVisible) return null;

  const getSkeletonClasses = () => {
    switch (variant) {
      case 'compact':
        return 'p-4 gap-2';
      case 'minimal':
        return 'p-3 gap-1';
      default:
        return 'p-6 gap-3';
    }
  };

  return (
    <div
      className={`absolute inset-0 z-50 flex flex-col bg-white ${getSkeletonClasses()} ${className}`}
    >
      {children || (
        <>
          {/* Header skeleton */}
          <div className="mb-4 flex items-center gap-3">
            <div className="size-10 animate-[shimmer_1.5s_infinite] rounded-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200px_100%] bg-[position:-200px_0]"></div>
            <div className="flex flex-1 flex-col gap-2">
              <div className="h-3 animate-[shimmer_1.5s_infinite] rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200px_100%] bg-[position:-200px_0]"></div>
              <div className="h-3 w-3/5 animate-[shimmer_1.5s_infinite] rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200px_100%] bg-[position:-200px_0]"></div>
            </div>
          </div>

          {/* Content skeleton */}
          <div className="mb-4 flex flex-1 flex-col gap-3">
            <div className="h-3 animate-[shimmer_1.5s_infinite] rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200px_100%] bg-[position:-200px_0]"></div>
            <div className="h-3 animate-[shimmer_1.5s_infinite] rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200px_100%] bg-[position:-200px_0]"></div>
            <div className="h-3 w-4/5 animate-[shimmer_1.5s_infinite] rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200px_100%] bg-[position:-200px_0]"></div>

            {/* Image placeholder */}
            <div className="my-3 h-24 animate-[shimmer_1.5s_infinite] rounded-lg bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200px_100%] bg-[position:-200px_0]"></div>

            <div className="h-3 animate-[shimmer_1.5s_infinite] rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200px_100%] bg-[position:-200px_0]"></div>
            <div className="h-3 w-[70%] animate-[shimmer_1.5s_infinite] rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200px_100%] bg-[position:-200px_0]"></div>
            <div className="h-3 animate-[shimmer_1.5s_infinite] rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200px_100%] bg-[position:-200px_0]"></div>
          </div>

          {/* Footer skeleton */}
          <div className="mt-auto flex justify-end gap-2">
            <div className="h-8 w-16 animate-[shimmer_1.5s_infinite] rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200px_100%] bg-[position:-200px_0]"></div>
            <div className="h-8 w-20 animate-[shimmer_1.5s_infinite] rounded bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200px_100%] bg-[position:-200px_0]"></div>
          </div>
        </>
      )}
    </div>
  );
};

export default OverlaySkeleton;
